import getApiClient from '@/plugins/api-client'
import Pagination from '@/util/pagination'

export default {
  name: 'Blocks',
  data: () => {
    return {
      blocks: [],
      api: null,
      pagination: new Pagination(),
    }
  },
  mounted: function () {
    this.api = getApiClient(this.$store)

    this.loadBlocks()
  },
  methods: {
    loadBlocks: function () {
      const params = this.pagination.getParams()
      this.api.get('/blocks', { params })
        .then(result => {
          this.blocks = result.data['hydra:member']
          this.pagination.updateData(result.data)
        })
        .catch(error => {
          console.info(error)
        })
    },
  },
}
